import { render, staticRenderFns } from "./Invite.vue?vue&type=template&id=47fafabf&scoped=true"
import script from "./Invite.vue?vue&type=script&lang=js"
export * from "./Invite.vue?vue&type=script&lang=js"
import style0 from "./Invite.vue?vue&type=style&index=0&id=47fafabf&prod&lang=scss&scoped=true"
import style1 from "./Invite.vue?vue&type=style&index=1&id=47fafabf&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47fafabf",
  null
  
)

export default component.exports